import styled from 'styled-components';

export const Container = styled.div`
  .btn-concluir {
    background-color: #e2e3e5;
    color: #000000;
    border: 1px solid #e2e3e5;
    border-radius: 4px;
    font-size: 14px;
  }

  .seta p {
    font-size: 12px;
  }

  .result-container {
    transition: all 1s;
  }

  .margin {
    margin-left: 30%;

    @media only screen and (max-width: 768px) {
      margin-left: 0%;
    }
  }

  .block {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .block-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
  }
  .video-container {
    position: relative;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;
